import React from "react";
import moment from "moment";

const ProjectSummary = ({ project, profile }) => {
  return (
    <div className="card project-summary">
      <div className="card-content grey-text text-darken-3">
        <span className="card-title">{project.title}</span>
        <p>
          Posted by: {project.authorFirstName} {project.authorLastName}
        </p>
        <p className="grey-text">
          Date: {moment(project.createdAt.toDate()).calendar()}
        </p>
      </div>
    </div>
  );
};

export default ProjectSummary;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSummary.jsx